import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

export class LanguageCustomLoader implements TranslateLoader {

  getTranslation(lang: string): Observable<any> {
    // Don't use paths array and foreach for file loading automatization.
    // There is probably some kind of racing and require() doesnt work properly inside loops.
    const homepageModuleJson = require(`./homepage/i18n/${lang}.json`);
    const sharedModuleJson = require(`./shared/i18n/${lang}.json`);
    const salonDetailsModuleJson = require(`./salon-details/i18n/${lang}.json`);
    const salonsSearchResultsModuleJson = require(`./salons-search-results/i18n/${lang}.json`);
    const bookingPartModuleJson = require(`./booking-part/i18n/${lang}.json`);
    const customerAccountModuleJson = require(`./customer-account/i18n/${lang}.json`);
    const authAccountModuleJson = require(`./auth/i18n/${lang}.json`);
    const visitReviewsModuleJson = require(`./visit-reviews/i18n/${lang}.json`);
    const giftsModuleJson = require(`./gifts/i18n/${lang}.json`);
    const mailingModuleJson = require(`./mailing/i18n/${lang}.json`);

    const jsonArray = [
      homepageModuleJson,
      sharedModuleJson,
      salonDetailsModuleJson,
      salonsSearchResultsModuleJson,
      bookingPartModuleJson,
      customerAccountModuleJson,
      authAccountModuleJson,
      visitReviewsModuleJson,
      giftsModuleJson,
      mailingModuleJson
    ];

    let completeI18n = {};
    jsonArray.forEach(jsonFile => {
      completeI18n = { ...jsonFile, ...completeI18n };
    });

    return of(completeI18n);
  }
}
